import React from 'react';
import {Link} from 'react-router-dom';
import NoPropertyPhoto from '../img/no-property-photo.png';
import {getFormatedCurrency, getOrdinalSuffix} from '../components/util';
import {ImageRewrite} from '../components/util.js';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'intersection-observer'; // optional polyfill
import Observer from '@researchgate/react-intersection-observer';

class MapPopup extends React.Component {
    constructor(props)
    {
        super(props);

        this.state = { carouselIndex: 0, showHouseDetail: true, propertyIndex: 0, changeProperty: false };
        this.carouselChangeHandle = this.carouselChangeHandle.bind(this);
        this.playdownMarker = this.playdownMarker.bind(this);
    }

    options = {
        onChange: this.handleIntersection,
        root: '#scrolling-container',
        rootMargin: '0px 300px',
    };

    carouselChangeHandle(index, element){
        if(index !== null && index !== undefined) {
            this.setState({ carouselIndex: index});
        }
        if(!this.state.changeProperty) {
            this.setState({showHouseDetail: false});
        }
        else{
            this.setState({changeProperty: false});
        }
    }
    
    handleIntersection(event) {
        //console.log(event.isIntersecting);
        if (event.isIntersecting) {
            event.target.src = event.target.attributes.getNamedItem('data-src').value;
        }
    }

    playdownMarker() {
        this.setState({showHouseDetail: true});
    }
    
    getCarouselDetail(carouselItems)
    {
        var carouselDetail = carouselItems;
        
            if(carouselItems !== null && carouselItems.length > 1) {
                carouselDetail =    <Carousel
                                        showThumbs={false}
                                        showIndicators={false}
                                        showArrows={true}
                                        swipeable={true}
                                        className='carousel_mappopup'
                                        infiniteLoop={true}
                                        selectedItem={this.state.carouselIndex}
                                        onChange={this.carouselChangeHandle}>
                                        {carouselItems}
                                    </Carousel>;
            }
            window.carouselDetail = carouselDetail;
            return carouselDetail;
    }

    showPrev = () => {
        //this.setState({ carouselIndex: 0 });
        var propertyIndex = (this.state.propertyIndex - 1);
        if(propertyIndex < 0){
            if(this.props.groupLst && this.props.groupLst.length > 1){
                propertyIndex = (this.props.groupLst.length - 1);
            }
            else{
                propertyIndex = 0;
            }            
        }
        this.setState({ changeProperty: true, carouselIndex: 0, propertyIndex: propertyIndex, showHouseDetail: true });
    }

    showNext = () => {
        //this.setState({ carouselIndex: 0 });
        var propertyIndex = (this.state.propertyIndex + 1);        
        if(this.props.groupLst && this.props.groupLst.length > 1){
            if(propertyIndex >= this.props.groupLst.length){
                propertyIndex = 0;    
            }
        }
        else{
            propertyIndex = 0;
        }            
        this.setState({ changeProperty: true, carouselIndex: 0, propertyIndex: propertyIndex, showHouseDetail: true });
    }

    getPropertyCarouselItems = (property) => {
        var imgTitle = "";
        var carouselItems = null;
        var purlPrefix = this.props.purlPrefix;
        const options = this.options;
        if (property && property.Photos && property.Photos.length > 0) {
            carouselItems = property.Photos.map(function (photo, i) {
                return (                    
                    <div key={i}>
                    <Link to={(property && property.Id) ? (`${purlPrefix.url}/propertydetail/` + property.Id + '/' + (property.SA ? property.SA.split(' ').join('-') : property.MN) + (property.CT ? '_' + property.CT.split(' ').join('-') : '') + (property.ST ? '_' + property.ST.split(' ').join('-') : '') + (property.PC ? '_' + property.PC.split(' ').join('-') : '')) : ('')}>
                        <Observer {...options}>
                            <img src={i === 0 ? ImageRewrite(photo, true) : NoPropertyPhoto} data-src={ImageRewrite(photo, true)} alt={imgTitle} />
                        </Observer>
                        </Link>
                    </div>
                );
            });
        } else {
            carouselItems =
                <div>
                    <img src={NoPropertyPhoto} alt={imgTitle} />
                </div>;
        }
        return carouselItems;
    }

    getCurrentPropertyContent = () => {
        var houseDetailClass = 'popup_property_info';

        if(this.state.showHouseDetail) {
            houseDetailClass += ' show_details';
        } else {
            houseDetailClass += ' hide_details';
        }

        var currProperty = null;
        if(this.props.property){
            currProperty = this.props.property;
        }
        if(this.props.groupLst && this.props.groupLst.length > 1){
            currProperty = this.props.groupLst[this.state.propertyIndex];
        }

        if(!currProperty) return null;

        return (
            <div className="property_popup" onMouseLeave={this.playdownMarker}>
                <div className={houseDetailClass} style={{paddingLeft: "0"}}>
                    <Link to={(currProperty && currProperty.Id) ? (`${this.props.purlPrefix.url}/propertydetail/` + currProperty.Id + '/' + (currProperty.SA ? currProperty.SA.split(' ').join('-') : currProperty.MN) + (currProperty.CT ? '_' + currProperty.CT.split(' ').join('-') : '') + (currProperty.ST ? '_' + currProperty.ST.split(' ').join('-') : '') + (currProperty.PC ? '_' + currProperty.PC.split(' ').join('-') : '')) : ('')}
                        className="no-link-effect">
                        <h4>{currProperty.SA}<span><i className="fa fa-map-marker"></i> {currProperty.CT + ', ' + currProperty.ST}</span> </h4>
                    </Link>
                    <div className="popup_facility_list">
                        <div className="star-rating">
                            <i className="fa fa-bed"></i>{currProperty.BD}
                        </div>
                        <div className="star-rating">
                            <i className="fa fa-bath"></i>{currProperty.BDI}
                        </div>
                        <div className="star-rating">
                            <i className="fa fa-car"></i>{currProperty.GR}
                        </div>
                        <div className="star-rating" style={{width: "40%"}}>
                            <i className="fa fa-arrows-alt"></i>{currProperty.LA + ' ft'}
                        </div>
                    </div>
                    <div className="popup_property_price">
                        <div className="price_left">
                            <span className="number-price">{getFormatedCurrency(currProperty.LP)}</span>
                        </div>
                        <div className="price_left">
                            <strong>MLS: </strong>{currProperty.MN}
                        </div>
                        <div className="price_right_tlc">
                        <span>TLC: </span>{getFormatedCurrency(currProperty.TLC)}
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
                <div className="popup_property_photo" style={{paddingRight: "0", display: 'inline'}}>                    
                    {this.getCarouselDetail(this.getPropertyCarouselItems(currProperty))}      
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="property_popup_wrapper">                
                {this.getCurrentPropertyContent()}
                {this.props.groupLst && this.props.groupLst.length > 1 &&
                    <div className="property_group_nav">
                        <div>
                            <div className="property_group_nav_btn" onClick={this.showPrev}>
                                <i className="fa fa-chevron-left"></i>
                            </div>
                            <div className="property_group_nav_content">
                                {"Showing " + (getOrdinalSuffix(this.state.propertyIndex + 1)) + " of " + this.props.groupLst.length + " Units"}
                            </div>
                            <div className="property_group_nav_btn right" onClick={this.showNext}>
                                <i className="fa fa-chevron-right"></i>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default MapPopup;